import { Redirect, Route, RouteProps } from "react-router-dom";

import {
  hasModuleAccess,
  UNAUTHORIZED_PATH,
  WmsModule,
} from "../utils/authorization";
import { useAuthContext } from "../store/AuthProvider";
import { useIdp } from "../store/IdpDiscoveryProvider";

type GroupProtectedRouteProps = RouteProps & {
  requiredModule: WmsModule;
  component: React.ComponentType;
};

/**
 * Requires authentication and membership in the IdP-specific WMS Admin group.
 */
export const GroupProtectedRoute = ({
  requiredModule,
  component: Component,
  ...routeProps
}: GroupProtectedRouteProps) => {
  const idp = useIdp();
  const { isAuthenticated, userInfo } = useAuthContext();

  return (
    <Route
      {...routeProps}
      render={(props) => {
        if (!isAuthenticated) {
          return <Redirect to='/' />;
        }
        if (!hasModuleAccess(userInfo?.groups, requiredModule, idp)) {
          return <Redirect to={UNAUTHORIZED_PATH} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

type GroupProtectedRouteChildrenProps = RouteProps & {
  requiredModule: WmsModule;
  children: React.ReactNode;
};

export const GroupProtectedRouteChildren = ({
  requiredModule,
  children,
  ...routeProps
}: GroupProtectedRouteChildrenProps) => {
  const idp = useIdp();
  const { isAuthenticated, userInfo } = useAuthContext();

  return (
    <Route
      {...routeProps}
      render={() => {
        if (!isAuthenticated) {
          return <Redirect to='/' />;
        }
        if (!hasModuleAccess(userInfo?.groups, requiredModule, idp)) {
          return <Redirect to={UNAUTHORIZED_PATH} />;
        }
        return <>{children}</>;
      }}
    />
  );
};
